import React from 'react';
import DefaultFooter from "./EventTagFooter";
import {
 AppFooter,
} from "@coreui/react";
import {Container} from "reactstrap";
import './event.scss';
import * as keys from "../../const/key/Key";

const App = () => {
  return (
      <div className="app event-app-download-wrapper">
        <div className="app-body">

          <main className="main margin-left239">
            <Container fluid>

              <div id="myModal" className="modal-wrapper">
                <div className="modal-dialog modal-confirm">
                  <div className="modal-content">
                    <div className="modal-header">
                      <div className="icon-box">
                        {/*<i className="material-icons">&#xE876;</i>*/}
                        <img src="/logos/event_logo.png" alt="play-store-badge"/>
                      </div>
                      <p className={"blue-color"}>Miracle Dome</p>
                    </div>
                    <br/>
                    <div className="modal-body">
                      <p className="text-center download-text">Download the App Now!
                      </p>
                    </div>
                    <div className="modal-footer">
                      <a className="store-btn wrapper-1" role="button"
                         href={keys.EVENT_APP_PLAY_STORE_APP}>
                        <img src="/app-assets/play-store-badge.png" alt="play-store-badge"/>
                      </a>
                      <a className="store-btn wrapper-2" role="button"
                         href={keys.EVENT_APP_APP_STORE_APP}>
                        <img src="/app-assets/app-store-badge.svg" alt="app-store-badge"/>
                      </a>
                    </div>
                  </div>
                </div>
              </div>

            </Container>
          </main>

        </div>

        <AppFooter>
          <DefaultFooter ROLE={""} class={"ml-none"}/>
        </AppFooter>

      </div>
  )
};
export default App;
